import React from 'react';
import PropTypes from 'prop-types';

import JobDescriptionView from './JobDescriptionView';

const DescriptionBox = (props) => {
  const {
    jobData,
  } = props;

  return (
    <JobDescriptionView
      jobData={jobData}
    />
  );
};
DescriptionBox.propTypes = {
  jobData: PropTypes.object.isRequired,
};

export default React.memo(DescriptionBox);
